"use client";

import { c as _c } from "react/compiler-runtime";
import { Check, Minus } from "lucide-react";
import { useI18n } from "@llmgateway/i18n/react";
interface FeatureRow {
  label: string;
  devpass: string | boolean;
  competitor: string | boolean;
  highlight?: boolean;
}
function Cell(t0) {
  const $ = _c(9);
  const {
    value,
    yesLabel,
    noLabel
  } = t0;
  if (typeof value === "boolean") {
    let t1;
    if ($[0] !== value) {
      t1 = value ? <Check aria-hidden="true" className="mx-auto h-4 w-4 text-foreground/70" /> : <Minus aria-hidden="true" className="mx-auto h-4 w-4 text-muted-foreground/40" />;
      $[0] = value;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = value ? yesLabel : noLabel;
    let t3;
    if ($[2] !== t2) {
      t3 = <span className="sr-only">{t2}</span>;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
      t4 = <>{t1}{t3}</>;
      $[4] = t1;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t1;
  if ($[7] !== value) {
    t1 = <span className="text-sm font-medium text-foreground">{value}</span>;
    $[7] = value;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}
export function ComparisonTable(t0) {
  const $ = _c(27);
  const {
    competitor,
    features
  } = t0;
  const {
    t
  } = useI18n();
  let t1;
  if ($[0] !== t) {
    t1 = t("compare.yes");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const yesLabel = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("compare.no");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const noLabel = t2;
  let t3;
  if ($[4] !== t) {
    t3 = t("compare.feature");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <th className="px-5 py-4 font-medium">{t3}</th>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <th className="px-5 py-4 text-center font-medium"><span className="font-semibold text-foreground">DevPass</span></th>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== competitor) {
    t6 = <th className="px-5 py-4 text-center font-medium"><span className="font-semibold text-foreground">{competitor}</span></th>;
    $[9] = competitor;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <thead><tr className="border-b bg-muted/40 text-xs uppercase tracking-wider text-muted-foreground">{t4}{t5}{t6}</tr></thead>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== features || $[15] !== noLabel || $[16] !== yesLabel) {
    let t9;
    if ($[18] !== features.length || $[19] !== noLabel || $[20] !== yesLabel) {
      t9 = (row, idx) => <tr key={row.label} className={idx !== features.length - 1 ? "border-b border-border/60" : ""}><td className={`px-5 py-3.5 ${row.highlight ? "font-semibold text-foreground" : "text-foreground/90"}`}>{row.label}</td><td className="px-5 py-3.5 text-center bg-muted/20"><Cell value={row.devpass} yesLabel={yesLabel} noLabel={noLabel} /></td><td className="px-5 py-3.5 text-center"><Cell value={row.competitor} yesLabel={yesLabel} noLabel={noLabel} /></td></tr>;
      $[18] = features.length;
      $[19] = noLabel;
      $[20] = yesLabel;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    t8 = features.map(t9);
    $[14] = features;
    $[15] = noLabel;
    $[16] = yesLabel;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[22] !== t8) {
    t9 = <tbody>{t8}</tbody>;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t7 || $[25] !== t9) {
    t10 = <div className="overflow-hidden rounded-2xl border bg-card shadow-sm"><div className="overflow-x-auto"><table className="w-full text-left text-sm">{t7}{t9}</table></div></div>;
    $[24] = t7;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}